import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const inTableFractionInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("in-table-fraction").default("in-table-fraction"),
      number: z.string().default(""),
      numerator: z.string().default(""),
      denominator: z.string().default("")
    }),
    shouldValidate: node => !!node.validation.correctAnswers.length,
    validate: (node, entry) => node.validation.correctAnswers.some(correctAnswer => (!correctAnswer.number || correctAnswer.number.trim() === entry.number.trim()) && correctAnswer.numerator.trim() === entry.numerator.trim() && correctAnswer.denominator.trim() === entry.denominator.trim()),
    parseLegacyDetailItem: (item, context) => {
      if (["WriteAnswers"].includes(context.relatedTask.taskType) && ["InTable"].includes(context.relatedTask.answerType ?? "") && item && typeof item === "object" && "numerator" in item && "denominator" in item && "number" in item) {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "in-table-fraction",
          number: item.number,
          denominator: item.denominator,
          numerator: item.numerator
        }];
      }
    }
  },
  schema: z.object({
    type: z.literal("Fraction"),
    correctAnswer: z.array(z.object({
      number: z.string().nullable().default(null),
      numerator: z.string().default(""),
      denominator: z.string().default("")
    }))
  }),
  postprocessSchemaInput: (input, context) => {
    return {
      id: `${context.taskId}-${context.rowIndex}-${context.index}`,
      nodeType: "in-table-fraction-input",
      meta: {
        rowIndex: context.rowIndex
      },
      validation: {
        correctAnswers: input.correctAnswer
      }
    };
  }
});

export { inTableFractionInput };
//# sourceMappingURL=input.fraction.js.map
